export default "__VITE_ASSET__CyA9uVkU__"